export default "__VITE_ASSET__dda680a5__"